import { useUnistyles } from "react-native-unistyles";
import { Stack } from "expo-router";
import { ScreenContainer, View } from "@src/components";
import { useTenant, useTenantId, AccountNotConfiguredView } from "@src/features/tenants";
import { TrafficFlowScreenContent } from "./TrafficFlowScreenContent";

export default function TrafficFlowScreen() {
  const { theme } = useUnistyles();
  const tenantId = useTenantId();
  const { error: tenantError, refreshTenants } = useTenant();

  const headerOptions = {
    title: "Traffic flow",
    headerStyle: { backgroundColor: theme.colors.background },
    headerTintColor: theme.colors.text,
    headerShadowVisible: false,
  };

  if (!tenantId) {
    return (
      <>
        <Stack.Screen options={headerOptions} />
        <AccountNotConfiguredView error={tenantError?.message} onRetry={() => void refreshTenants()} />
      </>
    );
  }

  return (
    <ScreenContainer edges={["top"]}>
      <Stack.Screen options={headerOptions} />
      <View flex={1} bg="background">
        <TrafficFlowScreenContent />
      </View>
    </ScreenContainer>
  );
}
